import request from '@/utils/request'

// 招生招聘
// 招聘信息 Recruitment/recruitmentInformation
export function recruitmentInformation(data) {
    return request({
      method: 'get',
      url: 'Recruitment/recruitmentInformation',
      params: data
    })
  }

// 招生信息 Recruitment/enrollmentInformation
export function enrollmentInformation(data) {
  return request({
    method: 'get',
    url: 'Recruitment/enrollmentInformation',
    params: data
  })
}




// WEBPACK FOOTER //
// ./src/api/Recruitment.js